import { Injectable } from "@angular/core";
import { CHttp } from "../../core/services/chttp.service";
import { config } from "../../app.config";
import { QueryParams, CancellationsQueryParams } from "../exit-survey.interfaces";

@Injectable()
export class ExitSurveyService {
  constructor(private http: CHttp) { }

  public getSurveryVersions() {
    return this.http.get(config.api_url + 'exit-surveys/versions');
  }

  public getAllSurveys(params: QueryParams) {
    return this.http.get(config.api_url + "exit-surveys/answers", {
      params,
    });
  }

  public getSurveyReasonStats(params: QueryParams) {
    return this.http.get(config.api_url + 'exit-surveys/reasons', {
      params,
    });
  }

  public getCancellationStats(params: CancellationsQueryParams) {
    return this.http.get(config.api_url + 'exit-surveys/cancellations', {
      params,
    });
  }

  public getSurvey(id: string) {
    return this.http.get(config.api_url + 'exit-surveys/answers/' + id);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/services/exit-survey.service.ts